import { ConsentPolicyKey } from '..';

export const dispatchPolicyChangedEvent = (policy: any) => {
  publishEvent(
    EVENT_NAMES.CONSENT_POLICY_CHANGED,
    [window as any, document],
    policy,
  );
};

export const dispatchManagerInitEvent = (currentPolicy: any) => {
  publishEvent(
    EVENT_NAMES.CONSENT_POLICIY_INITIALIZED,
    [window as any, document],
    currentPolicy,
  );
}

export const dispatchManagerReadyEvent = () => {
  publishEvent(
    EVENT_NAMES.CONSENT_POLICY_MANAGER_READY,
    [window as any, document],
    window.consentPolicyManager,
  );
}

export const dispatchPolicyUpdateRequestedEvent = (categories: ConsentPolicyKey[] = [])  => {
    const categoriesArray = Array.isArray(categories) ? categories : [];

    const filteredCategories = categoriesArray.filter(
      (value, index, array) => array.indexOf(value) === index,
    );

    const event =
      filteredCategories.length === 0 ? {} : { categories: filteredCategories };
    publishEvent(
      EVENT_NAMES.CONSENT_POLICY_UPDATE_REQUESTED,
      [window as any, document],
      event,
    );
}

export function publishEvent(
  eventName: string,
  publishingNode: Node[],
  eventData: any,
) {
  let customEvent: any;

  // @ts-expect-error
  const isIE: boolean = !!document.documentMode;
  if (isIE) {
    customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(eventName, true, false, eventData);
  } else {
    customEvent = new CustomEvent(eventName, {
      detail: eventData,
      bubbles: true,
    });
  }

  publishingNode.forEach((publishNode) => {
    if (publishNode && publishNode.dispatchEvent) {
      publishNode.dispatchEvent(customEvent);
    }
  });
}

export const EVENT_NAMES = {
  CONSENT_POLICY_MANAGER_READY: 'consentPolicyManagerReady',
  CONSENT_POLICIY_INITIALIZED: 'consentPolicyInitialized',
  CONSENT_POLICY_CHANGED: 'consentPolicyChanged',
  CONSENT_POLICY_UPDATE_REQUESTED: 'consentPolicyUpdateRequested',
};
